import { useSuspenseQuery } from "@tanstack/react-query";
import { Link } from "@tanstack/react-router";
import type { ReactNode } from "react";
import { hailArticleQuery } from "@/lib/hail-article-query";
import { HAIL_ARTICLE_SLUG } from "@/lib/hail-content";

/** Draft articles stay private and never become broken links on public pages. */
export function HailArticleLink({ children, prefix, className }: { children: ReactNode; prefix?: ReactNode; className?: string }) {
  const { data } = useSuspenseQuery(hailArticleQuery);
  if (!data) return null;
  return <>{prefix}<Link to="/blog/$slug" params={{ slug: HAIL_ARTICLE_SLUG }} className={className}>{children}</Link></>;
}